module.exports = __webpack_public_path__ + "img/sidebar-background-1.0a020050.svg";